module.exports = __webpack_public_path__ + "media/images/green_timer-ad0573f1be4585333cf1e073e0b54430.png";